/**
 * Students open the course on whatever phone they have, and some of those
 * are iPhones a few iOS versions behind. The build lowers syntax for them
 * but never adds missing built-ins, so the ones our dependencies call at
 * render time are filled in here, before anything else is imported.
 *
 * Object.hasOwn: react-markdown calls it on every render; Safari has it
 * only from 15.4.
 */
if (!Object.hasOwn) {
  Object.defineProperty(Object, 'hasOwn', {
    value: (object: object, key: PropertyKey) => Object.prototype.hasOwnProperty.call(object, key),
    configurable: true,
    writable: true,
  })
}

export {}
